function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Button, Input, Select, message, Alert } from "antd";
import { PersonFillUp } from 'react-bootstrap-icons';
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ForwardPatient = function ForwardPatient(_ref) {
  var handler = _ref.handler;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormLoading = _useState2[0],
      setIsFormLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      deptOptions = _useState4[0],
      setDeptOptions = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + "forwardpatient", {
      user_id: Common.currentUser.id,
      patient_id: values.patient_id,
      department_id: values.department_id
    }).then(function (response) {
      if (response.data.status == 200) {
        message.success({
          content: response.data.message,
          delay: 4
        });
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };

  useEffect(function () {
    axios.get(Common.baseApiUrl + "getservicetree").then(function (response) {
      if (response.data.status == 200) {
        response.data.services.forEach(function (d) {
          if (d.dcode == 'CON') setDeptOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: d.id,
              label: d.label
            }]);
          });
        });
      } else {
        message.error({
          content: "Une erreur est survenue",
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsFormLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      message: errorMessage,
      type: "error",
      showIcon: true
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      size: "large",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "CODE PATIENT",
        name: "patient_id",
        rules: [{
          required: true,
          message: "Veuillez indentifier le patient"
        }],
        children: /*#__PURE__*/_jsx(Input, {
          placeholder: "ENTREZ LE CODE PATIENT"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "CHOISIR LA SALLE",
        name: "department_id",
        rules: [{
          required: true,
          message: "Veuillez choisir une salle"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          placeholder: "Choisir une salle",
          options: deptOptions
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          type: "primary",
          htmlType: "submit",
          icon: /*#__PURE__*/_jsx(PersonFillUp, {
            size: 25
          }),
          children: " TRANSFERER "
        })
      })]
    })]
  });
};

export default ForwardPatient;